import { render, staticRenderFns } from "./ProductInstanceEdit.vue?vue&type=template&id=6d4d7f06&"
import script from "./ProductInstanceEdit.vue?vue&type=script&lang=js&"
export * from "./ProductInstanceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports